import React from "react";
import clsx from "clsx";
import { GreaterIcon } from "../../icons";

/**
 * Native select with registration form styling.
 * Chevron uses GreaterIcon + rotate-90 / rotate-270 (same as RDList Filter).
 */
const RegistrationFormSelect = ({
  className,
  onFocus,
  onBlur,
  onChange,
  ...rest
}) => (
  <div className="form-select-wrap">
    <select
      {...rest}
      className={clsx("form-input", "form-select", className)}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
    />
    <GreaterIcon
      height={14}
      width={14}
      fill="#6e7d8f"
      className="form-select-icon rotate-90"
      aria-hidden
    />
  </div>
);

export default RegistrationFormSelect;
